<!--
 * @Author: lishiqiao
 * @Date: 2022-01-14 15:29:28
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-11 15:27:10
-->
<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>公司&nbsp;:</label>
          <el-select v-model="params.params.orgId" placeholder="请选择公司">
            <el-option label="全部公司" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>造次&nbsp;:</label>
          <el-select v-model="params.params.periodId" placeholder="请选择造次">
            <el-option label="全部造次" value=""></el-option>
            <el-option v-for="item in periodList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="params.params.breedTypeId" placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option v-for="item in breedTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 选择日期年月日 -->
        <div class="page-search-date">
          <div class="page-search-item date-selection-box">
            <span @click="params.params.type = 'Y'" :class="[params.params.type == 'Y' ? 'active-date' : '']">年</span>
            <span @click="params.params.type = 'M'" :class="[params.params.type == 'M' ? 'active-date' : '']">月</span>
            <span @click="params.params.type = 'D'" :class="[params.params.type == 'D' ? 'active-date' : '']">日</span>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'Y'">
            <label>年份&nbsp;:</label>
            <el-date-picker value-format="yyyy" v-model="params.params.year" type="year" placeholder="请选择年份">
            </el-date-picker>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'M'">
            <label>月份&nbsp;:</label>
            <el-date-picker v-model="month" value-format="yyyy-MM" @change="monthChange" type="month" placeholder="选择月份">
              >
            </el-date-picker>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'D'">
            <label>日期&nbsp;:</label>
            <el-date-picker v-model="params.params.startDate" value-format="yyyy-MM-dd" @change="dateChange" type="date"
              placeholder="选择日期">
              >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <!-- 年报表 -->
        <div v-if="params.params.type == 'Y'">
          <i class="title-icon"></i>{{ showYear }}年养成收获年报表
        </div>
        <!-- 月报表 -->
        <div v-if="params.params.type == 'M'">
          <i class="title-icon"></i>{{ showMonth.substring(0, 4) }}年养成收获月报表
        </div>
        <!-- 日报表 -->
        <div v-if="params.params.type == 'D'">
          <i class="title-icon"></i>{{ showStartDate.substring(0, 4) }}年养成收获日报表
        </div>
        <div>单位 : {{ unitName }}</div>
        <!-- 年报表 -->
        <div v-if="params.params.type == 'Y'">年份 : {{ showYear }}年</div>
        <!-- 月报表 -->
        <div v-if="params.params.type == 'M'">月份 :{{ showMonth }}</div>
        <!-- 日报表 -->
        <div v-if="params.params.type == 'D'">
          日期 :
          {{ showStartDate }}
        </div>
        <div>
          <el-dropdown @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span style="margin-left: 20px;" @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格-年 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" v-show="params.params.type == 'Y'"
        :row-class-name="tableRowClassName" @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="单位名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="periodName" label="造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="品类"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"> </el-table-column>
        <el-table-column label="本年收获情况">
          <el-table-column prop="harvestBoxNum" label="塘数\箱数(口)">
          </el-table-column>
          <el-table-column prop="harvestArea" label="面积(亩)">
          </el-table-column>
          <el-table-column prop="harvestNum" :label="'收获数量\n(尾、粒)'">
          </el-table-column>
          <el-table-column prop="harvestWeight" :label="'收获重量\n(斤)'">
          </el-table-column>
          <el-table-column prop="avgYield" :label="'平均亩产\n(斤/亩)'">
          </el-table-column>
          <el-table-column prop="avgSpecification" :label="'平均规格\n虾\螺：尾(粒)/斤\n鱼：斤/尾'">
          </el-table-column>
        </el-table-column>
        <el-table-column label="与去年比完成情况">
          <el-table-column prop="harvestYieldLd" label="去年产量(斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldLdGap" label="增长量(斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldLdComplete" label="增幅%">
          </el-table-column>
        </el-table-column>
        <el-table-column :label="'(' + showYear + ')年度目标完成情况'">
          <el-table-column prop="harvestYieldTarget" label="计划产量(万斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldGap" label="完成差异量(万斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 表格-月 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" v-show="params.params.type == 'M'"
        :row-class-name="tableRowClassName" @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="单位名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="periodName" label="造次">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="品类">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种">
        </el-table-column>
        <el-table-column label="本月收获情况">
          <el-table-column prop="harvestBoxNum" label="塘数\箱数(口)">
          </el-table-column>
          <el-table-column prop="harvestArea" label="面积(亩)">
          </el-table-column>
          <el-table-column prop="harvestNum" :label="'收获数量\n(尾、粒)'">
          </el-table-column>
          <el-table-column prop="harvestWeight" :label="'收获重量\n(斤)'">
          </el-table-column>
          <el-table-column prop="avgYield" :label="'平均亩产\n(斤/亩)'">
          </el-table-column>
          <el-table-column prop="avgSpecification" :label="'平均规格\n虾\螺：尾(粒)/斤\n鱼：斤/尾'">
          </el-table-column>
        </el-table-column>
        <el-table-column label="本月累计收获情况">
          <el-table-column prop="harvestBoxNumCy" label="塘数\箱数(口)">
          </el-table-column>
          <el-table-column prop="harvestAreaCy" label="面积(亩)">
          </el-table-column>
          <el-table-column prop="harvestNumCy" :label="'收获数量\n(尾、粒)'">
          </el-table-column>
          <el-table-column prop="harvestWeightCy" :label="'收获重量\n(斤)'">
          </el-table-column>
          <el-table-column prop="avgYieldCy" :label="'平均亩产\n(斤/亩)'">
          </el-table-column>
          <el-table-column prop="avgSpecificationCy" :label="'平均规格\n虾\螺：尾(粒)/斤\n鱼：斤/尾'">
          </el-table-column>
        </el-table-column>
        <el-table-column label="与去年同期月比完成情况">
          <el-table-column prop="harvestYieldLd" label="去年同期产量(斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldLdGap" label="增长量(斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldLdComplete" label="增幅%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="与去年同期月累计比完成情况">
          <el-table-column prop="harvestYieldLy" label="去年同期产量(斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldLyGap" label="增长量(斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldLyComplete" label="增幅%">
          </el-table-column>
        </el-table-column>
        <el-table-column :label="'(' + showMonth.substring(0, 4) + ')年度目标完成情况'">
          <el-table-column prop="harvestYieldTarget" label="计划产量(万斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldGap" label="完成差异量(万斤)">
          </el-table-column>
          <el-table-column prop="harvestYieldComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 表格-日 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" v-show="params.params.type == 'D'"
        :row-class-name="tableRowClassName" @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="单位名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="periodName" label="造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="品类"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"> </el-table-column>
        <el-table-column label="本日收获情况">
          <el-table-column prop="harvestBoxNum" label="塘数\箱数(口)">
          </el-table-column>
          <el-table-column prop="harvestArea" label="面积(亩)">
          </el-table-column>
          <el-table-column prop="harvestNum" label="收获数量(尾、粒)">
          </el-table-column>
          <el-table-column prop="harvestWeight" label="收获重量(斤)">
          </el-table-column>
          <el-table-column prop="avgSpecification" :label="'平均规格\n虾\螺：尾(粒)/斤\n鱼：斤/尾'">
          </el-table-column>
        </el-table-column>
        <el-table-column label="本日累计收获情况">
          <el-table-column prop="harvestBoxNumCy" label="塘数\箱数(口)">
          </el-table-column>
          <el-table-column prop="harvestAreaCy" label="面积(亩)">
          </el-table-column>
          <el-table-column prop="harvestNumCy" label="收获数量(尾、粒)">
          </el-table-column>
          <el-table-column prop="harvestWeightCy" label="收获重量(斤)">
          </el-table-column>
          <el-table-column prop="avgSpecificationCy" :label="'平均规格\n虾\螺：尾(粒)/斤\n鱼：斤/尾'">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import service from "./yc-harvest-service";
import Page from "@/utils/methods/page";
export default {
  name: "yc-harvest-output",
  data() {
    return {
      month: "",
      PageDisplay: true,
      unitName: "", // 单位名称
      showYear: "", // 显示的年份
      showMonth: "",// 显示的月份
      showStartDate: "", // 显示的开始日期
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "orgName",
          fixed: false,
          selected: false
        },
        {
          prop: "periodName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "org_name",
        params: {
          rootOrgId: "",
          orgId: "",
          breedTypeId: "",
          periodId: "",
          breedId: "",
          year: localStorage.getItem("year") ? localStorage.getItem("year") : this.$moment().year().toString(),
          startDate: "",
          endDate: "",
          type: "Y",
          breedTypeClass: "fish",
        },
      },
      exportParams: {}, // 导出参数
      tableData: [],
      companyList: [], // 公司列表
      periodList: [], // 造次列表
      breedTypeList: [], // 品类列表
      breedList: [], // 品种列表
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.params.rootOrgId = localStorage.getItem("rootId");
    this.getCompanyList(); // 获取公司列表
    this.getPeriodList(); // 获取造次列表
    this.getBreedTypeList(); // 获取品类列表
    this.getBreedList(); // 获取品种列表
    this.getPageList(); // 获取分页
  },
  mounted() {
    // Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val;
      this.params.params.endDate = val;
    },

    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val;
      this.params.params.endDate = val;
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 09:48:20
     * @description: 获取公司列表
     * @param {*}
     */
    getCompanyList() {
      service
        .getOutPutCompanyList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.companyList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 09:49:55
     * @description: 获取造次列表
     * @param {*}
     */
    getPeriodList() {
      service
        .getOutPutPeriodList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.periodList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 09:50:20
     * @description: 获取品类列表
     * @param {*}
     */
    getBreedTypeList() {
      service
        .getOutputBreedTypeList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.breedTypeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 09:50:39
     * @description: 获取品种列表
     * @param {*}
     */
    getBreedList() {
      service
        .getOutPutBreedList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.breedList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 初始化时间
    initTime() {
      this.params.params.year = null;
      this.params.params.startDate = null;
      this.params.params.endDate = null;
      this.month = "";
      if (this.params.params.type == "Y") {
        this.params.params.year = localStorage.getItem("year") ? localStorage.getItem("year") : this.$moment().year().toString();
      }
      if (this.params.params.type == "M") {
        this.params.params.startDate = this.$moment().format("YYYY-MM");
        this.params.params.endDate = this.$moment().format("YYYY-MM");
        this.month = this.params.params.startDate;
      }
      if (this.params.params.type == "D") {
        this.params.params.startDate = this.$moment().format("YYYY-MM-DD");
        this.params.params.endDate = this.$moment().format("YYYY-MM-DD");
      }
    },

    // 重置
    reset() {
      this.params.params.orgId = "";
      this.params.params.periodId = "";
      this.params.params.breedTypeId = "";
      this.params.params.breedId = "";
      this.initTime();
      this.getPageList();
    },

    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },

    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.orgName === "合计") {
        return "heji-row";
      }
    },

    // 显示的单位-年-月-日
    showListData() {
      if (this.params.params.year) {
        this.showYear = this.params.params.year;
      }
      if (this.params.params.orgId) {
        this.unitName = this.companyList.filter(
          (item) => item.id == this.params.params.orgId
        )[0].name;
      } else {
        this.unitName = "水产养殖事业部";
      }
      if (this.params.params.type == "M") {
        this.showMonth = this.$moment(this.params.params.startDate).format(
          "YYYY年MM月"
        );
      }
      if (this.params.params.type == "D") {
        this.showStartDate = this.$moment(this.params.params.startDate).format(
          "YYYY年MM月DD日"
        );
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-12 11:01:40
     * @description: 获取收获概览-产量报表-养成日期分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getOutPutPageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.tableData = res.data.list;
            this.showListData();
            this.exportParams = JSON.parse(JSON.stringify(this.params.params));
          } else {
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-10 15:49:07
     * @description:导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.exportParams.fileName = "养成收获概览产量";
          service
            .exportOutPutData(this.exportParams)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => {
          // this.$message.error(err);
        });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  watch: {
    // 监听type年月日变化
    "params.params.type"(val) {
      this.initTime();
      this.getPageList();
    },
  },
};
</script>

<style scoped></style>